const portfolioSkeleton1 = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='600'
		height='595'
		viewBox='0 0 600 595'>
		<g
			id='Group_22153'
			data-name='Group 22153'
			transform='translate(-308 -2614)'>
			<rect
				id='Rectangle_1742'
				data-name='Rectangle 1742'
				width='600'
				height='450'
				transform='translate(308 2614)'
				fill='#f0f0f0'
			/>
			<g
				id='Group_21506'
				data-name='Group 21506'>
				<rect
					id='Rectangle_2159'
					data-name='Rectangle 2159'
					width='300'
					height='43'
					rx='4'
					transform='translate(308 3094)'
					fill='#f0f0f0'
				/>
				<rect
					id='Rectangle_2160'
					data-name='Rectangle 2160'
					width='150'
					height='28'
					rx='4'
					transform='translate(308 3145)'
					fill='#f0f0f0'
				/>
				<rect
					id='Rectangle_2161'
					data-name='Rectangle 2161'
					width='75'
					height='28'
					rx='4'
					transform='translate(308 3181)'
					fill='#f0f0f0'
				/>
			</g>
		</g>
	</svg>
);

const portfolioSkeleton2 = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='600'
		height='955'
		viewBox='0 0 600 955'>
		<g
			id='Group_22154'
			data-name='Group 22154'
			transform='translate(-1012 -2614)'>
			<g
				id='Group_21507'
				data-name='Group 21507'
				transform='translate(704 360)'>
				<rect
					id='Rectangle_2159'
					data-name='Rectangle 2159'
					width='300'
					height='43'
					rx='4'
					transform='translate(308 3094)'
					fill='#f0f0f0'
				/>
				<rect
					id='Rectangle_2160'
					data-name='Rectangle 2160'
					width='150'
					height='28'
					rx='4'
					transform='translate(308 3145)'
					fill='#f0f0f0'
				/>
				<rect
					id='Rectangle_2161'
					data-name='Rectangle 2161'
					width='75'
					height='28'
					rx='4'
					transform='translate(308 3181)'
					fill='#f0f0f0'
				/>
			</g>
			<rect
				id='Rectangle_2078'
				data-name='Rectangle 2078'
				width='600'
				height='810'
				transform='translate(1012 2614)'
				fill='#f0f0f0'
			/>
		</g>
	</svg>
);

export { portfolioSkeleton1, portfolioSkeleton2 };
